import { OrderHistoryCompo } from "@/components";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useCustomPaginatedOrders } from "@/hooks";
import { cn } from "@/lib/utils";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setOrderHistory } from "@/store/slices/appSlice";

import { LoaderCircle, Zap } from "lucide-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
const orderHistory = [
  {
    id: "ORD-1234",
    datePlaced: "3/15/2025",
    status: "Delivered",
    totalAmount: 245.97,
    itemCount: 6,
    actions: {
      viewDetails: true,
      pickUpOptions: false,
      reorder: true,
    },
  },
  {
    id: "ORD-1185",
    datePlaced: "2/28/2025",
    status: "Processing",
    totalAmount: 128.5,
    itemCount: 3,
    actions: {
      viewDetails: true,
      pickUpOptions: true,
      reorder: true,
    },
  },
  {
    id: "ORD-1092",
    datePlaced: "1/12/2025",
    status: "Picked Up",
    totalAmount: 387.25,
    itemCount: 8,
    actions: {
      viewDetails: true,
      pickUpOptions: false,
      reorder: true,
    },
  },
];

const OrderHistory = ({className}: {className?: string}) => {
  const { orderHistory } = useAppSelector((state) => state.app);
  const { user } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const [historyLoading, setHistoryLoading] = useState(false);
  const handlePickUpOptions = useCallback(
    (data: { orderId: string; deliveryMethod: string; storeLocation?: string }) => {},
    []
  );

  const [fetchFlags, setFetchFlags] = useState({
    orders: false,
  });
  const variables = useMemo(() => {
    return {
      filter: {
        user_id: { eq: user?.user_id || "" },
      },
    };
  }, [user]);
  useEffect(() => {
    setFetchFlags({
      orders: !orderHistory || orderHistory.length === 0,
    });
    //eslint-disable-next-line
  }, []);
  const { orders, loadPage } = useCustomPaginatedOrders({
    limit: 25,
    skip: !fetchFlags.orders,
    setLocalLoading: setHistoryLoading,
    infoVariablesP: variables,
  });
  useEffect(() => {
    if (fetchFlags.orders) {
      loadPage();
    }
  }, [fetchFlags.orders]);
  useEffect(() => {
    if (!historyLoading && fetchFlags.orders) {
      setFetchFlags((prev) => ({
        orders: false,
      }));

      dispatch(setOrderHistory(orders));
    }
    //eslint-disable-next-line
  }, [historyLoading]);

  return (
    <div className={cn(`container mx-auto py-10 px-4 max-w-6xl`, className)}>
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-3xl font-bold">Order History</h1>
        <Link to="/quick-reorder" className="inline-flex items-center">
          <Button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 bg-primary text-primary-foreground hover:bg-[#333333] hover:text-white h-10 px-4 py-2">
            <Zap className="size-4" />
            Quick Reorder
          </Button>
        </Link>
      </div>
      <ScrollArea className="h-[80vh] pr-4  ">
        {historyLoading ? (
          <div className="flex items-center justify-center w-full h-[60vh] ">
            <LoaderCircle className="w-6 h-6 animate-spin mr-4 "></LoaderCircle>
            Fetching order history. This won’t take long!
          </div>
        ) : !historyLoading && orderHistory?.length === 0 ? (
          <div className="flex items-center justify-center w-full h-[60vh]">
            No orders found. Start shopping to place your first order!
          </div>
        ) : (
          <OrderHistoryCompo
            orders={orderHistory ?? []}
            handlePickUpOptions={handlePickUpOptions}
          />
        )}{" "}
      </ScrollArea>
    </div>
  );
};

export default OrderHistory;
